import React, { Fragment } from 'react';

/**
 * Blockchain Contract complete component
 * 
 * Shows contract status after all steps are completed
 */
export function ContractComplete({contractBc, userType}) {
    const isContractor = userType === 'contractor';

    return (
        <Fragment>
            <div className='col-sm-12'>
                <div>
                    <span className='fw-bold'>Interaction with this contract is complete</span>
                </div>
                <div>
                    <span>Contract balance: </span>
                    <span className='text-success'>{contractBc?.contract?.balance} ETH</span>
                </div>
                {
                contractBc?.contract?.amountToContractor > 0 &&
                <div>
                    <span>Amount transferred to { !isContractor ? 'Contractor' : 'your wallet'}: </span>
                    <span className='text-success'>{contractBc?.contract?.amountToContractor} ETH</span>
                </div>
                }
                {
                contractBc?.contract?.amountToHomeowner > 0 &&
                <div>
                    <span>Amount transferred to { isContractor ? 'Homeowner' : 'your wallet'}: </span>
                    <span className='text-success'>{contractBc?.contract?.amountToHomeowner} ETH</span>
                </div>
                }
            </div>
        </Fragment>
    );
}